<template>
  <div class="register-page">
    <div class="wrapper wrapper-full-page ">
      <div class="full-page register-page section-image">
        <div class="content" id="register-page-content">
          <div class="container">
            <div class="row justify-content-md-center">
              <div id="header-text" class="col-md-auto">
                  <h2><center><img :src="logo"  style="display: inline"> Kobotrack</center></h2>
                  <h4><center>Begin your journey to a better financial life</center></h4>
              </div>
            </div>  
            <div class="row">
              <div class="col-lg-4 col-md-6 ml-auto">
                <card type="signup" class="text-center">
                  <template slot="header">
                    <h4 class="card-title">Register</h4>
                  </template>

                  <fg-input name="firstName"
                            type="text"
                            v-model="model.firstName"
                            v-validate="modelValidations.firstName"
                            :error="getError('firstName')"
                            addon-left-icon="nc-icon nc-single-02" placeholder="First Name..."></fg-input>
                  
                  
                  <fg-input name="lastName"
                            type="text"
                            v-model="model.lastName"
                            v-validate="modelValidations.lastName"
                            :error="getError('lastName')"
                            addon-left-icon="nc-icon nc-circle-10" placeholder="Last Name..."></fg-input>
                  
                  <fg-input name="email"
                            type="email"
                            v-model="model.email"
                            v-validate="modelValidations.email"
                            :error="getError('email')"
                            addon-left-icon="nc-icon nc-email-85" placeholder="Email..."></fg-input>

                  <fg-input name="password"
                            type="password"
                            v-model="model.password" ref="password"
                            v-validate="modelValidations.password"
                            :error="getError('password')"
                            addon-left-icon="nc-icon nc-key-25" placeholder="Password..."></fg-input>

                  <fg-input name="confirmPassword"
                            type="password"
                            v-model="model.confirmPassword" 
                            v-validate="modelValidations.confirmPassword"
                            :error="getError('confirmPassword')"
                            addon-left-icon="nc-icon nc-key-25" placeholder="Confirm Password..."></fg-input>
                  
                  
                  <p>By clicking button below, you agree to Kobotrack's <a href="" target="_blank">terms and conditions</a></p>

                  <p-button slot="footer" type="info" @click.prevent="validate" :disabled="isDisabled" round>{{ createButtonText }}</p-button>
                  <p slot="footer">
                    Already have an account? <router-link :to="{name: 'Login'}">Login</router-link> 
                  </p>
                </card>
              </div>
              <div class="col-lg-5 col-md-5 mr-auto">
                <info-section class="mt-5"
                              type="primary"
                              title="Transactions"
                              description="View transactions from all your bank accounts in one place. Easily tie your expense to your planned budget. 
                    Track your way to reaching your financial goals."
                              icon="ti-exchange-vertical">

                </info-section>
                <info-section type="primary"
                              title="Financial Services"
                              description="Invest, save, borrow, lend, buy at discount, earn loyalty points on purchases all in one place. And it is free."
                              icon="ti-plug">

                </info-section>

                <info-section type="primary"
                              title="Community"
                              description="Join a diverse community of people working towards better financial health."
                              icon="ti-user">

                </info-section>
              </div>
            </div>
          </div>
        </div>
      <app-footer></app-footer>
      </div>
    </div>
    
  </div>
</template>
<script>
  import auth from 'src/auth'

  import AppNavbar from './Layout/AppNavbarRegister'
  import AppFooter from './Layout/AppFooterLogin'
  import { Card, Checkbox, Button, InfoSection } from 'src/components/UIComponents';
  import NotificationTemplate from '../Components/NotificationTemplate'

  export default {
    components: {
      Card,
      AppNavbar,
      AppFooter,
      InfoSection,
      [Checkbox.name]: Checkbox,
      [Button.name]: Button,
      NotificationTemplate
    },
    data(){
      return { 
        
        createButtonText: 'Create Account',
        registrationError: false,
        failedRegistration: false,
        isDisabled: false,
        model: {
          firstName: '',
          lastName: '',
          email: '',
          password: '',
          confirmPassword: '',
        },
        modelValidations: {
          firstName: {
            required: true,
            alpha: true
          },
          lastName: {
            required: true,
            alpha: true
          },
          email: {
            required: true,
            email: true
          },
          password: {
            required: true
          },
          confirmPassword: {
            required: true,
            confirmed: 'password'
          },
        }
      }
    },
    props:{
      logo:{
        type: String,
        default: 'static/img/kobotrack-logo.png'
      }
    },
    methods: {
      notifyVue(theMessage) {
        this.$notify(
        {
          message: theMessage,
            
        })
      },
      toggleNavbar() {
        document.body.classList.toggle('nav-open')
      },
      closeMenu() {
        document.body.classList.remove('nav-open')
        document.body.classList.remove('off-canvas-sidebar')
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          if(isValid){
            this.register()
          }
        })
      },
      register (){
        this.isDisabled = true
        this.createButtonText='Creating Your Account ...'
        this.failedRegistration = false
        this.registrationError = false
        
        var bodyFormData = new FormData();
        bodyFormData.append('name', this.model.firstName + ' ' + this.model.lastName);

        bodyFormData.append('email', this.model.email);
        bodyFormData.append('password', this.model.password);
        bodyFormData.append('password_confirmation', this.model.password);
        bodyFormData.append('grant_type', 'password');
        bodyFormData.append('client_id', 4);
        bodyFormData.append('client_secret', 'B6yRpuLktGzkH7TwUpzqR4C5J2zS8YLGnCS84KrE');
        bodyFormData.append('scope', '*');

        this.$http({
          method: "post",
          url: '/register',
          data: bodyFormData,
          headers: { "Content-Type": "application/x-www-form-urlencoded"},
        })
        .then(response=>{
          if(response.data.access_token){
            auth.setToken(response.data.access_token)
            auth.setHeaderAuthorization(this.$http)
            this.$router.push('/verify')
          }else{
            this.isDisabled = false
            this.failedRegistration = true
            this.createButtonText='Try Creating Free Account Again'
          }
        })
        .catch(error =>{
          //what to do when there is an error with the registration
          this.isDisabled = false
          this.registrationError = true
          this.createButtonText='Try Creating Account Again'
          this.notifyVue('Whoops. Something went wrong')
        })
      }
    },
    beforeDestroy() {
      this.closeMenu()
    },
    
    mounted: function () {
      if (this.$route.query.email) {
        this.model.email = this.$route.query.email
      }
    }
  }
</script>
<style>
  #header-text h4, #header-text h2 {color: white;  margin-top: 0px !important; }
  #header-text {margin-bottom: 15px !important }
  #header-text img {padding-bottom: 10px;}
  #register-page-content {padding-top: 20px !important;}
</style>
